import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
	selector: 'vb-scrub-bar-progress',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: ``,
	standalone: false,
	styleUrls: ['./VbScrubBarProgress.Component.ng.less']
})
export class VbScrubBarProgressComponent {
	@Input() @HostBinding('style.width') public progressPercentage: string;
}
